import NextLink from 'next/link'
import { PaginationItem, Pagination as View } from 'ui-components'
import { getWorkspacesLink } from 'utils'

import { useGetWorkspaces } from '~workspaces/queries/useGetWorkspaces'

export function Pagination() {
  const { page, limit, total } = useGetWorkspaces()

  return (
    <View
      page={page}
      limit={limit}
      total={total}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          component={NextLink}
          href={getWorkspacesLink(item.page || 1)}
        />
      )}
    />
  )
}
